import React from 'react';

const CATEGORY_COLORS = {
  kombucha: '#6B4226',
  waterKefir: '#2E7D6B',
  switchel: '#B8860B',
  fermentedVeg: '#4A7C3F',
  brines: '#1A5276'
};

export default function ProductionLogList({ logs, onEdit, onDelete, onFile, canFile, showFileButton }) {
  if (logs.length === 0) {
    return <div className="pl-empty">No batches found.</div>;
  }

  return (
    <div className="pl-list">
      {logs.map((log, i) => {
        const fileCheck = canFile ? canFile(log) : { ok: false };
        let phReadings = [];
        try { phReadings = JSON.parse(log.phReadings || '[]'); } catch {}
        const validReadings = phReadings.filter(r => r.actual);

        return (
          <div key={i} className="pl-card">
            <div className="pl-card-accent" style={{ backgroundColor: CATEGORY_COLORS[log.category] }} />
            <div className="pl-card-body">
              <div className="pl-card-top">
                <span className="pl-category-badge" style={{ backgroundColor: CATEGORY_COLORS[log.category] }}>
                  {log.categoryLabel}
                </span>
                <span className="pl-batch-id">ID: {log.batchId}</span>
                {log.filed === 'yes' && <span className="pl-filed-badge">Filed</span>}
              </div>
              <div className="pl-card-flavor">{log.flavor || '—'}</div>
              <div className="pl-card-meta">
                <span>Started: {log.startDate ? new Date(log.startDate).toLocaleDateString() : '—'}</span>
                {log.expirationDate && <span>BBD: {log.expirationDate}</span>}
                {log.packDate && <span>Packed: {log.packDate}</span>}
                {log.loggedBy && <span>By: {log.loggedBy}</span>}
              </div>
              <div className="pl-card-details">
                {log.volumeGallons && <span>Volume: {log.volumeGallons} gal</span>}
                {log.kegs && <span>Kegs: {log.kegs}</span>}
                {log.cans && <span>Cans: {log.cans}</span>}
                {log.batchWeightLbs && <span>Weight: {log.batchWeightLbs} lbs</span>}
                {log.jarCount && <span>Jars: {log.jarCount}</span>}
                {log.bottleCount && <span>Bottles: {log.bottleCount}</span>}
                {log.specificGravity && <span>SG: {log.specificGravity}</span>}
              </div>
              {validReadings.length > 0 && (
                <div className="pl-ph-summary">
                  {validReadings.map((r, j) => (
                    <span key={j} className="pl-ph-chip">
                      pH {r.actual} {r.date ? `(${new Date(r.date).toLocaleDateString()})` : ''}
                    </span>
                  ))}
                </div>
              )}
              {log.arIngredients && (() => {
                try {
                  const ings = JSON.parse(log.arIngredients);
                  if (ings.length > 0) return (
                    <div className="pl-ar-tag">
                      🌱 {ings.map(i => `${i.amount} ${i.unit} ${i.name}`).join(', ')}
                    </div>
                  );
                } catch {}
              })()}
              {log.correctiveAction && <div className="pl-corrective">⚠️ {log.correctiveAction}</div>}
              {log.qualityNotes && <div className="pl-notes">✓ {log.qualityNotes}</div>}
              {log.notes && <div className="pl-notes">📝 {log.notes}</div>}
              {showFileButton && !fileCheck.ok && (
                <div className="pl-file-warning">⚠️ {fileCheck.reason}</div>
              )}
            </div>
            <div className="pl-card-actions">
              <button className="pl-btn-edit" onClick={() => onEdit(log)}>Edit</button>
              {showFileButton && (
                <button
                  className={`pl-btn-file ${fileCheck.ok ? '' : 'disabled'}`}
                  onClick={() => fileCheck.ok && onFile(log)}
                  title={fileCheck.ok ? 'File this batch' : fileCheck.reason}
                >File</button>
              )}
              <button className="pl-btn-delete" onClick={() => onDelete(log)}>Delete</button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
